import { getSchoolMajors,getCourses } from '@/api/common'

const state = {
}

const mutations = {
}

const actions = {
  getcourses({ commit }) {
    return new Promise((resolve, reject) => {
      getCourses().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getschoolmajors({ commit }) {
    return new Promise((resolve, reject) => {
      getSchoolMajors().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
